// src/client.ts
import createFetchClient from "openapi-fetch";
var createApiClient = (options) => {
  const headers = {
    retries: 0,
    "Cache-Control": "no-cache"
  };
  return createFetchClient(options ?? { headers });
};
export {
  createApiClient
};
